// componente per la visualizzazione della pagina di inserimento/modifica di un pannello (componente sinistra)
// nella pagina "Pannelli"

import { Component, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/service/alert.service';

import { ApiService } from '../../../../service/api.service';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';

import { Exceptions } from '../exceptions.model';
import { ExceptionsService } from '../exceptions.service';
import { ExceptionsListComponent } from '../exceptions-list/exceptions-list.component';

@Component({
  selector: 'app-exceptions-edit',
  templateUrl: './exceptions-edit.component.html',
  styleUrls: ['./style.scss']
})
export class ExceptionsEditComponent implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) exceptionsForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode = false; // variabile posta a true se è attiva la modifica di un pannello
  oldId = 0; // ID del pannello prima della modifica
  editExceptionsId = 0; // ID del pannello da modificare
  exceptions: Exceptions; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  plantcodes: string[]
  availablepersons: string[]
  alarmcodes: string[]
  levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]


  constructor(private als: AlertService, private exceptionsService: ExceptionsService, private exceptionsList: ExceptionsListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }

  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this

    this.dataStorageService.getPlantsList().subscribe(v => {
      this.plantcodes = v
    })
    this.dataStorageService.getAvailablesList().subscribe(v => {
      this.availablepersons = v
    })
    this.dataStorageService.getAlarmcodesList().subscribe(v => {
      this.alarmcodes = v
    })
    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile
    this.bodyid = this.auth.currentUserValue.bodyid

    // si riempie la form coi valori preimpostati
    this.subscription = this.exceptionsService.exceptionsEditMode.subscribe(
      (id: number) => {
        me.exceptions = me.exceptionsService.getExceptionsByIndex(id);
        me.oldId = me.exceptions.id
        this.exceptionsForm.setValue({
          plantcode: me.exceptions.plantcode ? me.exceptions.plantcode : "",
          alarmcode: me.exceptions.alarmcode ? me.exceptions.alarmcode : "",
          level: me.exceptions.level ? me.exceptions.level : "",
          availableperson: me.exceptions.availableperson ? me.exceptions.availableperson : "",
          voice: me.exceptions.voice ? me.exceptions.voice : "",
          sms: me.exceptions.sms ? me.exceptions.sms : "",
          mail: me.exceptions.mail ? me.exceptions.mail : "",
          tag: me.exceptions.tag ? me.exceptions.tag : "",
        });
        me.editExceptionsId = id;
        me.editMode = true;
      }
    );
  }
  first(value) {
    var temp = value.split(" - ")
    return temp[0]
  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxExceptions().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Exceptions(v,
          me.first(value.plantcode),
          me.first(value.alarmcode),
          value.level,
          value.availableperson,
          value.voice,
          value.sms,
          value.mail,
          value.tag
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeExceptions(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.exceptions = mess;
        me.exceptionsService.addExceptions(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.utilsService.hideLoader();
          me.onClear();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_exceptions = new Exceptions(me.oldId,
        me.first(value.plantcode),
        me.first(value.alarmcode),
        value.level,
        value.availableperson,
        value.voice,
        value.sms,
        value.mail,
        value.tag
      );

      // si richiamano i servizi di aggiornamento tabella
      me.exceptions = new_exceptions;
      me.exceptions.id = me.editExceptionsId;
      var res = this.exceptionsList.getIndex(this.exceptions.id)
      me.exceptionsService.updateExceptions(res, me.exceptions);
      me.exceptions.id = me.oldId

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateExceptions(me.exceptions)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.utilsService.hideLoader();
        me.onClear();
      }, 1000)
    }
  }

  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    this.exceptionsForm.setValue({
      plantcode: '',
      alarmcode: '',
      level: '',
      availableperson: '',
      voice: false,
      sms: false,
      mail: false,
      tag: ''
    });
    this.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm("Sei sicuro di voler eliminare l'eccezione?").subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteExceptions(me.exceptions.id)

        // ...il messaggio viene eliminato dalla tabella...
        me.exceptionsService.deleteExceptions(me.exceptions.id);

        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;

        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }
  import() {

    var me = this
    const dialogRef = this.dialog.open(Upload4, {});
    dialogRef.afterClosed().subscribe(result => {
      me.dataStorageService.getExceptions();
      me.utilsService.hideLoader();
    });
  }
}

@Component({
  selector: 'upload',
  templateUrl: 'file-upload.component.html',
  styleUrls: ['./style.scss']
})
export class Upload4 implements OnInit {

  constructor(public dialogRef: MatDialogRef<Upload4>, public dataStorageService: ApiService, private utilsService: UtilsService) { }
  fileToUpload: File = null;
  jsontosave
  loaded
  ngOnInit() {

  }
  handleFileInput(files: FileList) {
    var me = this
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: string = reader.result as string;
        me.jsontosave = me.csvJSON(csv)
        me.loaded = true
      }
    }
  }
  uploadFileToActivity() {
    var me = this
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (this.readyState == 4 && (this.status == 200 || this.status == 500)) {
        me.dialogRef.close();
      }
    };
    xmlHttp.open("POST", 'https://sosimperium.multiutilitydelgarda.eu:8001/csvexceptions', false); // false for synchronous request
    xmlHttp.setRequestHeader("Content-type", "application/json");
    xmlHttp.send(this.jsontosave);
    me.loaded = false
    // this.dataStorageService.storeCsvExceptions(this.jsontosave)
  }

  csvJSON(csv) {
    var lines = csv.split("\n");
    var result = [];
    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {

      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        if (headers[j] && currentline[j]) {
          headers[j] = headers[j].replace(/[\n\r]+/g, '');
          currentline[j] = currentline[j].replace(/[\n\r]+/g, '');
          obj[headers[j]] = currentline[j];
        }
      }

      result.push(obj);

    }
    return JSON.stringify(result); //JSON
  }
}